#import "@core/schema/fragments/PublicCourseTermFull.graphql"

query (
  $courseType: CourseType
  $limit: Int
  $nextToken: String
) {
  listPublishedFutureCourseTerms(
    courseType: $courseType
    limit: $limit
    nextToken: $nextToken
  ) {
    nextToken
    items {
      ...PublicCourseTermFull
    }
  }
}
